/**
 * Env keys are upper snake case, URL params are their lower case counterpart.
 * The `PARAM_` prefix only exists to namespace the env/managed variant
 * (`PARAM_DEV` -> `?dev=1`).
 */
export const getUrlKey = (key: string) =>
  key.replace(/^PARAM_/, '').toLowerCase()

/**
 * Reads a query param on web, `undefined` everywhere else.
 * Accepts either an env key (`PARAM_DEV`) or a raw param name (`dev`).
 */
export const getUrlParam = (key: string) => {
  if (typeof window === 'undefined') {
    return undefined
  }

  try {
    return (
      new URLSearchParams(window.location.search || '').get(getUrlKey(key)) ??
      undefined
    )
  } catch (error) {
    console.log('Failed to get web param', error)
    return undefined
  }
}
